import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { fromEvent, interval } from 'rxjs';

const STORAGE_KEY = 'dpis-app-version';
const CHECK_INTERVAL_MS = 2 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  readonly version = signal('');
  private started = false;

  constructor(private http: HttpClient) {}

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;
    const metaVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content');
    if (metaVersion) {
      this.version.set(metaVersion);
    }
    this.check();
    interval(CHECK_INTERVAL_MS).subscribe(() => this.check());
    fromEvent(window, 'focus').subscribe(() => this.check());
  }

  private check(): void {
    this.http.get<{ version?: string }>(`/api/appversion?t=${Date.now()}`).subscribe({
      next: (result) => {
        const nextVersion = result?.version;
        if (!nextVersion) {
          return;
        }
        this.version.set(nextVersion);
        let previous = '';
        try {
          previous = sessionStorage.getItem(STORAGE_KEY) ?? '';
        } catch {
          return;
        }
        if (previous && previous !== nextVersion) {
          if (!this.canReload()) {
            return;
          }
          try {
            sessionStorage.setItem(STORAGE_KEY, nextVersion);
          } catch {
            return;
          }
          window.location.reload();
          return;
        }
        try {
          sessionStorage.setItem(STORAGE_KEY, nextVersion);
        } catch {
          return;
        }
      },
      error: () => undefined,
    });
  }

  private canReload(): boolean {
    const el = document.activeElement as HTMLElement | null;
    if (!el) {
      return true;
    }
    const tag = el.tagName;
    return tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT' && !el.isContentEditable;
  }
}
